import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Editor.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-r24-black flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/brand/logo.jpg" alt="Rapid24News" className="h-16 w-16 rounded-full object-cover ring-2 ring-r24-red mx-auto mb-3" />
          <div className="font-head font-bold text-2xl text-white">RAPID<span className="text-r24-red">24</span>NEWS</div>
          <div className="text-xs uc tracking-widest text-gray-500 mt-1">Newsroom Admin</div>
        </div>
        <form onSubmit={submit} className="bg-white p-6" data-testid="admin-login-form">
          <h1 className="font-head font-bold text-xl uc mb-5">Editor Login</h1>
          <label className="font-head font-semibold uc text-xs">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="admin-email"
            className="w-full border-2 border-gray-300 focus:border-r24-red outline-none px-3 py-2 mt-1 mb-4" />
          <label className="font-head font-semibold uc text-xs">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" data-testid="admin-password"
            className="w-full border-2 border-gray-300 focus:border-r24-red outline-none px-3 py-2 mt-1 mb-5" />
          <button disabled={loading} data-testid="admin-login-submit" className="w-full bg-r24-red text-white font-bold uc py-3 hover:bg-r24-reddark disabled:opacity-50">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
